import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, IconButton, ButtonBase, } from '@material-ui/core';


class NewsItem extends React.Component {

    _onClickNews = () => {
        const { data } = this.props;
        this.props.history.push({ pathname: '/newsdetail/' + data.id, data: data });
    }

    render() {
        const { classes, data } = this.props;
        return (
            <Grid item container direction='column' className={classes.root} justifyContent='center'>
                <ButtonBase disableRipple className={classes.buttonBase}
                    style={{
                        // backgroundSize: 'cover',
                        // backgroundImage: `url(${data.imgUrl})`,
                        // backgroundRepeat: 'no-repeat',
                        marginTop: 0,
                        marginRight: 0,
                        marginLeft: 0,
                        marginBottom: 0,
                    }}
                    onClick={() => this._onClickNews(data)} >

                    <img src={data.imgUrl} className={classes.image} />

                </ButtonBase>
                <Typography align='left' noWrap className={classes.subTitle}>{data.title}</Typography>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: 'calc(50vw - 16px)',
        borderRadius: 10,
    },
    image: {
        width: 'calc(50vw - 16px)',
        height: '26vw',
        borderRadius: 6,
        // object-fit: cover;
        objectFit: 'cover'
    },
    buttonBase: {
        width: 'calc(50vw - 16px)',
        height: '26vw',
        borderRadius: 6,

        // justifyContent: 'center',
        // alignItems: 'center',
        backgroundColor: '#e6e6e6'
    },
    subTitle: {
        color: '#0D0D0D',
        fontSize: 13,
        marginTop: 8,
        marginRight: 8,
        maxWidth: 'calc(50vw - 16px)'
    },
}))(NewsItem));